<template>
  <div>
    <div class="map">
      <Facets />
      <MapGoogle />
    </div>
    <div>
      <Districts />
      <Criteria />
    </div>
  </div>
</template>

<script>
import Criteria from './criteria/Criteria';
import Districts from './districts/Districts';
import Facets from './facets/Facets';
import MapGoogle from './MapGoogle';
import { mapActions } from 'vuex';

export default {
    name: 'Map',
    components: { Districts, Facets, MapGoogle, Criteria },
    methods: {
        ...mapActions('facets', {
            initialize: 'initialize',
        }),
    },
    mounted () {
        this.initialize();
    },
};
</script>

<style scoped>
.map {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
}

@media (max-width: 800px) {
  .map {
    flex-direction: column-reverse;
  }
}
</style>
